var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"footer"},[_vm._v(" copyright@rjc.org版权所有2021上海口袋阿姨职业技能培训有限公司 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }